import { EntityServices } from "@sdk/utils/entity.service";
import type { PaginatedOptions, PaginatedResults } from "@sdk/utils/paginated-results";
import type { iCustomerInvoice } from "@sdk/bookings/booking-model";
import { postAccountingListReport } from "@sdk/accounting/accounting-list-report.service";
import type { CustomerInvoiceListRow } from "@sdk/accounting/accounting-list-report.models";

export class CustomerInvoicesServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.customerInvoices.configure(config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.customerInvoices = Object.assign(
      new EntityServices<iCustomerInvoice>(config, "customer-invoices", {}),
      {
        report: (req: {
          query: Record<string, unknown>;
          options?: PaginatedOptions;
        }) =>
          postAccountingListReport<CustomerInvoiceListRow>(
            config,
            "customer-invoices",
            req
          ),
      }
    );
    this.customerInvoices.configure(config);
  }

  customerInvoices!: EntityServices<iCustomerInvoice> & {
    report: (req: {
      query: Record<string, unknown>;
      options?: PaginatedOptions;
    }) => Promise<PaginatedResults<CustomerInvoiceListRow>>;
  };
}
